import React from 'react';
// import FileBase64 from 'react-file-base64';
// import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom'
// import Button from '@material-ui/core/Button';
// import * as actions from './redux/actions';
// import { postsState$ } from './redux/selectors';
import Header from './components/Header';
import RouterContainer from './components/RouterContainer';
import Footer from './components/Footer';
import ScrollTop from './components/ScrollTop';
import GlobalLoading from './components/GlobalLoading';
import Notification from './components/Notification';

function App() {
  // const [attachment, setAttachment] = React.useState('');
  // const dispatch = useDispatch();
  // const posts = useSelector(postsState$);
  // console.log('postsList', posts);

  // React.useEffect(() => {
  //   dispatch(actions.getLatestPosts.getPostsRequest());
  //   console.log(attachment);
  // }, [dispatch, attachment]);

  return (
    <Router>
      <Header />
      <RouterContainer />
      <ScrollTop />
      <Footer />
      <GlobalLoading />
      <Notification />
      {/* <FileBase64
        accept="image/*"
        multiple={false}
        type="file"
        value={attachment}
        onDone={({ base64 }) => setAttachment(base64)}
      />
      <div>
        <Button variant="contained" color="primary">Create</Button>
      </div> */}
    </Router>
  );
}

export default App;
